import { useEffect, useState } from 'react';
import { isBrowser } from '~/utils';

interface UseIsStickyByIdProps {
  id: string;
  stickyTop: number;
  threshold?: number;
}
export const useIsStickyById = ({ id, stickyTop, threshold = 0 }: UseIsStickyByIdProps) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    if (!isBrowser()) return;

    const el = document.getElementById(id);
    if (!el) return;

    const checkSticky = () => {
      const rect = el.getBoundingClientRect();
      setIsSticky(rect.top <= stickyTop + threshold);
    };

    checkSticky();
    window.addEventListener('scroll', checkSticky);
    window.addEventListener('resize', checkSticky);

    return () => {
      window.removeEventListener('scroll', checkSticky);
      window.removeEventListener('resize', checkSticky);
    };
  }, [id, stickyTop, threshold]);

  return isSticky;
};
